<template>
  <div
    class="productlist custom-full-border"
    :id="product ? product.tiptiles ? 'productlist-' + 'tiptile-' +  product.tiptiles.id : 'productlist-' + product.id : null"
    :class="[callerComp === 'Similar Products' ? 'similiarProdMobile' : '', product && product.tiptiles ? 'h-full' : 'productCard']"
  >
        
   <router-link
      v-if="!(product && product.tiptiles)"
      :to="navigateToProd()"
    >
      <div
        @click="trigerEvent(position)" class="imgBlock custom-border"
        v-lazyloadImage="{...getTatvicprImpression, isSelectedCountryIndia, enableVisenzeSearch : enableVincenzeSearch && enableVincenzeSearch.status, widget_current_route : currentRouteMoengage}"
        :class="'listhover ' + pclass"
      >
        <div class="listhoverimg" :data-url="baseImgPath+path+(parry && parry[1])"></div>
        <carousel 
          v-if="showCarouselImages"
          ref="myCarousel" :perPage="1" :navigationEnabled="false" :paginationEnabled="false"
          navigationNextLabel="" :paginationPadding="2" :paginationSize="7"
          paginationPosition="bottom" navigationPrevLabel=""
          :easing="'linear'" :speed="2000"
        >
          <slide v-for="(pr, index) in product.images" :key="index">
            <img 
              :src="baseImgPath + path + (pr) && baseImgPath + path + (parry && parry[index])"
              fallback="https://tss-static-images.gumlet.io/blankimg.jpg"
              :placeholder="'https://tss-static-images.gumlet.io/blankimg.jpg'"
              :blur="20"
              v-imageBackground="isPrImgMounted ? '1080:1440' : ''"
              :alt="`${productTitle} ${listCat} Online`"
              :title="`${productTitle} ${listCat} at The Souled Store`"
              @load="loadimage(index, product.images.length)"
              class="img-auto"
              width="280"
              height="370"
            />
          </slide>
        </carousel>
        <img v-else fallback="https://tss-static-images.gumlet.io/blankimg.jpg"
          :placeholder="'https://tss-static-images.gumlet.io/blankimg.jpg'"
          :blur="20"
          v-imageBackground="isPrImgMounted ? '1080:1440' : ''"
          :data-url="baseImgPath+path+(parry && parry[0])"
          :alt="`${productTitle} ${listCat} Online`"
          :title="`${productTitle} ${listCat} at The Souled Store`"
          @load="loadimage"
          class="customFade custom-border img-auto"
          :class="(timerData && timerData.showBlur) || (product && product.isBlurOnPlp) ? 'img-blur' : ''"
          width="280"
          height="370"
        />
        <div class="ratingPLP" v-if="avgRating >= 1 && bannerplprating">
          <span>{{ avgRating }}</span>
          <img src="https://w7.pngwing.com/pngs/566/674/png-transparent-green-star-blue-angle-leaf-thumbnail.png" class="starRating"/>
          <div>|</div>
          <span>{{ getDataValue(ratingCount) }}</span>
        </div>
        <!-- <progressive-img src="catImgPath + bimg.filename" /> -->
        <div :class="showImageBlurSoldOutDesign ? 'souled-out-image-blur': 'souledout'" v-if="(prodType === 1 || prodType === 6) && pstock <= 0">{{showImageBlurSoldOutDesign ? 'Souled Out' : ''}}</div>
        <div :class="showImageBlurSoldOutDesign ? 'souled-out-image-blur': 'souledout'" v-else-if="prodType === 3 && isStockConfig <= 0">{{showImageBlurSoldOutDesign ? 'Souled Out' : ''}}</div>
        <div :class="showImageBlurSoldOutDesign ? 'souled-out-image-blur': 'souledout'" v-if="souledout">{{showImageBlurSoldOutDesign ? 'Souled Out' : ''}}</div>
        <div class="coming-soon" v-else-if="prodType === 1 && pstock <= 0 && urlKey === 'harry-potter-hufflepuff-sigil-scarf'">coming soon</div>
        <div class="mockup-tag"
          :class="getMockUpTagPositionClass(mockUpTag.tag_position)"
          v-if="mockUpTag && Object.keys(mockUpTag).length"
        >
          <span
          :style="{backgroundColor: mockUpTag.background_color, color: mockUpTag.text_color}"
          >
            {{mockUpTag.tag_name}}
          </span>
        </div>
        <div v-if="timerData && Object.keys(timerData).length" class='pabsolute timer-container w-full d-flex flex-column justify-content-center align-items-center'>
          <CountdownPLP
            :starttime="timerData.startDate"
            :endtime="timerData.endDate"
            :color="timerData.timerColor"
            v-if="timerData.showCountDown"
            :showTimer="timerData.showTimer"
            :pretext="timerData.liveSaleText"
            :showEarlyText="timerData.showEarlyText"
            :days="timerData.days"
            :minutes="timerData.minutes"
            :hours="timerData.hours"
            :seconds="timerData.seconds"
            :now="timerData.now"
            callerComp="imgBlock"
          />
        </div>
      </div>
      <div style="padding:0px 5px 0px 10px;" v-if="product && (!product.isProductLocked || !product.targetDate)"> 
        <div :style="isDesktop ? 'display: grid;' : 'display:flex;'">
          <h5 class="text-left" style="color: #585C70;">{{ productTitle }}</h5>
          <div
            v-if="isWishlist(prm) && isBlurProductClickablePdp"
            class="wishlistIcon pl-1 pb-2 pr-1"
            :style="callerComp !== 'Search Page' && callerComp !== 'PLP Page' ? 'right: 35px !important;' : ''"
            :class="prm.id && wishlistItemsIDs && wishlistItemsIDs[prm.id] ? 'wishlistActive' : 'wishlist'"
            @click.prevent="updateWishlist(prm, $event, position)"
          ></div>
        </div>
        <div class="row">
          <div class="col-12 d-flex justify-content-between" style="" :title="productCat">
            <!-- <div class='listprice ecltext' :class="mockUpLabel && Object.keys(mockUpLabel).length && isLabelLieInTime ? 'category-txt' : ''">
              <span style="font-size: 10px;" v-if="listCat">{{ listCat }}</span>
              <span  style="font-size: 10px;" >{{ productCat }}</span>
            </div> -->
            <div class="listprice ecltext" :class="mockUpLabel && Object.keys(mockUpLabel).length && isLabelLieInTime ? 'category-txt' : ''">
              <span :style="{ fontSize: !this.isDesktop ? '11px' : '' }" v-if="listCat">{{ listCat }}</span>
              <span :style="{ fontSize: !this.isDesktop ? '11px' : '' }" v-else>{{ productCat }}</span>
            </div>
            <div v-if="mockUpLabel && Object.keys(mockUpLabel).length && isLabelLieInTime" class='d-flex align-items-center label-container prelative'>
              <i class="fa fa-bolt pabsolute" :style="{borderColor: mockUpLabel.label.label_background_color}"></i>
              <span class="fbold ecltext" :style="{backgroundColor: mockUpLabel.label.label_background_color, color: mockUpLabel.label.label_text_color}">{{mockUpLabel.label.label_name}}</span>
            </div>
          </div>
          <div class="col-12" style="padding-right:0px;" v-if="productPrice">
            <span v-if="getround(spprice) || (isExclusive && getround(exclusivePrice))">
              <div class="row">
                <div class="col-12 special-products_pricing">
                  <span v-if="isExclusive && showMemberExclusivePrice && getround(exclusivePrice)" class="membership-product-price">
                    <span  style="color:#121212;">Membership Price</span>
                    <span class="fsemibold" style="color:#121212;">{{ currencySymbol }} {{(exclusivePrice && getround(exclusivePrice) || 0)}}</span>
                  </span>
                  <span v-else class="offer fsemibold">{{ currencySymbol }} {{isExclusive ? (exclusivePrice && getround(exclusivePrice) || 0) :spprice && getround(spprice)}}</span>
                  <span class="product-price" style="text-decoration: line-through; color:#ccc;">{{ currencySymbol }} {{ getround(productPrice) }}</span>
                  <span class="percentage-off" v-if="!isExclusive && spprice > 0">
                    <span v-if="isNonExclusiveSavingsInPercent">
                      {{`${getround((productPrice - (isExclusive ? exclusivePrice : spprice)) / productPrice * 100)}%`}} {{(nonMemberSavingsTxt && nonMemberSavingsTxt.tag_text) || 'OFF'}}
                    </span>
                    <span v-else>{{ currencySymbol }}
                      {{`${getround(productPrice) - getround((isExclusive ? exclusivePrice : spprice))}`}} {{(nonMemberSavingsTxt && nonMemberSavingsTxt.tag_text) || 'OFF'}}
                    </span>
                  </span>
                </div>
              </div>
            </span>
            <span v-else-if="['50000-points-offer', '25000-points-offer', '12000-points-offer'].includes(urlKey)">{{ currencySymbol }} {{ $parent.$parent.currencyFormate(getround(productPrice)) }}</span>
            <span class="offer fsemibold" v-else>{{ currencySymbol }} {{ productPrice && getround(productPrice) }}</span>
            <!-- <span class="mrp-text" v-if="showPriceInclusiveOnPlp && isSelectedCountryIndia">{{ showPriceInclusiveOnPlp.tag_text }}</span>
            <span class="mrp-text" v-if="showMrpOnPlpGlobal && !isSelectedCountryIndia">{{ showMrpOnPlpGlobal.tag_text }}</span> -->
            <span class="mrp-text" :style="{ fontSize: !isDesktop ? '13px' : '' }" v-if="showPriceInclusiveOnPlp && isSelectedCountryIndia">{{ showPriceInclusiveOnPlp.tag_text }}</span>
            <span class="mrp-text" :style="{ fontSize: !isDesktop ? '13px' : '' }" v-if="showMrpOnPlpGlobal && !isSelectedCountryIndia">{{ showMrpOnPlpGlobal.tag_text }}</span>

          </div>
          <div v-if="gstInClusiveLabel && Object.keys(gstInClusiveLabel).length" class="gstInclusiveLabel">
            <span :style="`color: ${gstInClusiveLabel.banner_text_color}; background: ${gstInClusiveLabel.banner_color};`">{{gstInClusiveLabel.tag_text}}</span>
          </div>
          <div class="col-12 percentage-off member-savings pb-1" v-if="getround(exclusivePrice) && getround(productPrice) && isExclusive && !showMemberExclusivePrice">
            <span v-if="isExclusiveSavingsInPercent">{{getround(((productPrice - exclusivePrice) / productPrice) * 100)}}% {{(memberSavingsTxt && memberSavingsTxt.tag_text) || 'Member Savings'}}</span>
            <span v-else>{{(memberSavingsTxt && memberSavingsTxt.tag_text) || 'Member Savings'}} {{ currencySymbol }} {{getround(productPrice) - getround(exclusivePrice)}}</span>
          </div>
          <!-- <div class="col-12 percentage-off member-savings pb-1" v-else>&nbsp;</div> -->
        </div>
        <div class="ex-price" @click="togglePopup(EXCLUSIVE_PRODUCT)" v-if="this.$route.path === '/artists/exclusive-deals' && !isExclusive">For Excl. Member <i class="fa fa-info-circle pointer"></i><span class="fbold" style="float: right;">{{ currencySymbol }} {{ exclusivePrice }}</span></div>
      </div>
      <div class="notify-me-btn" v-if="product && product.isProductLocked">
        <notifyMe :parentid="product.id" :proType="product.isProductLocked && isTargetDateInFuture ? 'TIMER' : product.isProductLocked ? 'LOCK' : ''" :isOptions="true" :product="product"></notifyMe>
      </div>
      <div class="countdown-timer" v-if="product && product.isProductLocked && isTargetDateInFuture">
        <CountdownTimer :targetDate="product.targetDate"/>
      </div>
    </router-link>
    <div v-else class="imgBlock h-full">
      <a class='h-full' v-bannerImageLoad="getBannerImpressionData" v-if="product.tiptiles.isClickable && product.tiptiles.navLink && isExternalLink(product.tiptiles.navLink)" :href="product.tiptiles.navLink" target="_blank" rel="noopener noreferrer">
        <img class='h-full w-full fit-cover customFade'
          :data-url="parry[0]" :alt="productTitle" @load="loadimage" @click="tiptileClick"
        />
      </a>
      <router-link v-bannerImageLoad="getBannerImpressionData" class='h-full' v-else-if="product.tiptiles.isClickable && product.tiptiles.navLink" :to="product.tiptiles.navLink"  :class="'listhover ' + pclass">
        <img class='h-full w-full fit-cover customFade'
          :data-url="parry[0]" :alt="productTitle" @load="loadimage" @click="tiptileClick"
        />
      </router-link>
      <div v-else v-bannerImageLoad="getBannerImpressionData" class='pointer-none h-full'>
        <img class='h-full w-full fit-cover customFade'
          :data-url="parry[0]" :alt="productTitle" @load="loadimage" @click="tiptileClick"
        />
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import CountdownPLP from './CountdownPLP.vue'
  import notifyMe from './notifyMe.vue'
  import CountdownTimer from './CountdownTimer.vue'
  import moment from 'moment/src/moment'
  import {isDesktop, getProductUrl} from '@/assets/js/common'
  import {appMixins} from '../../assets/js/appMixins'
  import getLastPage from '../../assets/js/getLastPage'
  import Vue from 'vue'
  export default {
    mixins: [appMixins],
    props: {
      parry: Array,
      urlKey: String,
      imageH: Number,
      imageW: Number,
      product: Object,
      productTitle: String,
      avgRating: Number,
      ratingCount: Number,
      bannerplprating: Object,
      productCat: String,
      productPrice: '',
      pstock: Number,
      spprice: '',
      position: Number,
      exclusivePrice: '',
      pclass: String,
      listCat: String,
      isStockConfig: Number,
      prodType: Number,
      // isExclusive: Boolean,
      togglePopup: Function,
      souledout: Boolean,
      jitValue: String,
      scrollToProduct: Function,
      plpMockUpTags: Array,
      genderType: Number,
      index: Number,
      showImageBlurSoldOutDesign: Boolean,
      timerData: Object,
      callerComp: String,
      headingTitle: String,
      searchTerm: String,
      gstInClusiveLabel: Object,
      prm: Object,
      wishlistItemsIDs: null,
      updateWishlist: Function,
      hideWishlist: Boolean,
      saleDet: Object,
      size: String
    },
    components: {CountdownPLP, notifyMe, CountdownTimer},
    data () {
      return {
        baseImgPath: process.env.IMG_BASE_URL,
        imgSize: `cdn-cgi/image/width=${this.imageW},height=${this.imageH},quality=100/`,
        path: process.env.PRODUCT_IMG,
        EXCLUSIVE_PRODUCT: process.env.EXCLUSIVE_PRODUCT,
        IMG_URL: process.env.PROD_IMG,
        now: '',
        exclusiveTimer: {
          TIMER_START: process.env.TIMER_START,
          TIMER_END: process.env.TIMER_END
        },
        isPrImgLoaded: false,
        isPrImgMounted: false,
        labelTimeInterval: null,
        isLabelLieInTime: false,
        isDesktop: isDesktop()
      }
    },
    methods: {
      getDataValue: function (number) {
        const units = ['', 'k Ratings', 'm Ratings', 'b Ratings']
        let unitIndex = 0
        while (number >= 1000 && unitIndex < units.length - 1) {
          number /= 1000
          unitIndex++
        }
        return number + units[unitIndex]
      },
      trigerEvent: function (index) {
        Vue.ls.set('widget_click_position', {route: getLastPage(this.$route.name), name: this.headingTitle || this.callerComp || ''})
        this.$store.commit('GTAG_EVENT', {eventName: 'similar-product', payload: {index}})
        this.$store.commit('SET_NAVIGATION_WIDGET', this.callerComp || 'Listing')
        this.productClickEventHandler()
      },
      navigateToProd () {
        let url = this.productCat === 'Exclusive'
          ? '/exclusive'
          : '/product/' + this.urlKey + '?gte=' + (this.genderType || 0)
        if (this.product && this.isBlurProductClickable && this.product.isBlurOnPlp) {
          return (url)
        } else if (this.product && !this.product.isProductLocked && !this.product.isBlurOnPlp) {
          return (url)
        }
      },
      productClickEventHandler () {
        let obj = {}
        const widgetClickPosition = Vue.ls.get('widget_click_position') || {}
        const gender = Vue.ls.get('tss_landingCategory')
        let localPayload = {...this.getTatvicprImpression}
        if (localPayload && localPayload.searchTerm && localPayload.searchTerm.length) {
          obj.SEARCH_TERM = localPayload.searchTerm
          delete localPayload.searchTerm
        }
        this.$store.commit('MOENGAGE_EVENT', {
          eventName: 'WIDGET-CLICK',
          payload: {
            Section_Name: this.headingTitle || '',
            Section_Index: Number(this.index),
            Product_Category: String(this.listCat || this.productCat),
            Product_Name: this.productTitle || '',
            Product_ID: (this.product && this.product.id) || '',
            Product_Price: this.exclusivePrice || this.spprice ? this.isExclusive ? this.exclusivePrice : this.spprice : this.productPrice,
            Product_Artist: this.productCat,
            ProductImage_URL: String(this.baseImgPath + this.path + (this.parry && this.parry[0])),
            Product_URL: this.getProductUrl(true, this.urlKey, this.genderType),
            GENDER: gender,
            widget_name: (this.headingTitle && this.headingTitle.toLowerCase()) || (this.callerComp && this.callerComp.toLowerCase()),
            widget_click_position: widgetClickPosition && widgetClickPosition.route,
            widget_current_route: getLastPage(this.$route.name)
          }
        })
        this.$store.dispatch('ECOMMERCE_EVENT', {eventName: 'select_item',
          payload: {
            'items': [
              localPayload
            ],
            ...obj
          }
        })
        if ((this.callerComp === 'Search Page' || this.callerComp === 'Recommended Products') && this.enableVincenzeSearch && this.isSelectedCountryIndia) {
          this.$store.commit('VINSENZE_EVENT', {
            eventName: 'product_click',
            payload: {
              queryId: localStorage.getItem('visenze_queryId') || 'none',
              pid: Number(this.product && this.product.id),
              pos: this.position + 1,
              imUrl: String(this.baseImgPath + this.path + (this.parry && this.parry[0]))
            }
          })
        }
        this.$store.commit('MOENGAGE_EVENT', {
          eventName: 'PLP-LISTCLICK',
          payload: {
            Product_Category: String(this.listCat || this.productCat),
            Product_Name: String(this.product),
            Product_ID: Number(this.product && this.product.id),
            Product_Price: Number(this.exclusivePrice || this.spprice ? this.isExclusive ? this.exclusivePrice : this.spprice : this.productPrice),
            Product_Artist: String(this.productCat),
            Quantity: 1,
            Size: String(this.size),
            ProductImage_URL: String(this.baseImgPath + this.path + (this.parry && this.parry[0])),
            Product_URL: this.getProductUrl(false, this.urlKey, ''),
            PLP_index: Number(this.index),
            isUserLoggedIn: this.authStatus ? this.authStatus : false
          }
        })
      },
      tiptileClick () {
        const bannerImpressionData = this.getBannerImpressionData
        this.$store.dispatch('ECOMMERCE_EVENT', {eventName: 'select_promotion',
          payload: {
            creative_name: bannerImpressionData.creative_name ? bannerImpressionData.creative_name : 'NA',
            creative_slot: bannerImpressionData.creative_slot || bannerImpressionData.creative_slot === 0 ? bannerImpressionData.creative_slot : 'NA',
            promotion_id: bannerImpressionData.promotion_id ? bannerImpressionData.promotion_id : 'NA',
            promotion_name: bannerImpressionData.promotion_name ? bannerImpressionData.promotion_name : 'NA'
          }
        })
      },
      getround: function (val) {
        return parseInt(val)
      },
      loadimage (index, totalPages) {
        if (this.position === 0 && index === totalPages - 1) {
          const self = this
          setTimeout(() => {
            self.$emit('carousel-images-loaded', true)
          }, 300)
          setTimeout(() => {
            self.$emit('carousel-images-loaded', false)
          }, 5000)
        }
        if (this.scrollToProduct) {
          this.scrollToProduct()
        }
        this.isPrImgLoaded = true
      },
      removeChar (str) {
        var b
        if (str) {
          b = str.slice(0, -1)
        } else {
          b = str
        }
        return b
      },
      formatTime: function (date) {
        let d = date ? new Date(date) : new Date()
        return [
          d.getFullYear(),
          ('0' + (d.getMonth() + 1)).slice(-2),
          ('0' + d.getDate()).slice(-2)
        ].join('-') + ' ' +
          [('0' + d.getHours()).slice(-2),
            ('0' + d.getMinutes()).slice(-2),
            ('0' + d.getSeconds()).slice(-2)
          ].join(':')
      },
      isInViewport (elem) {
        var bounding = elem.getBoundingClientRect()
        return (
            bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
        )
      },
      scrollHandler () {
        let $productId = this.product.tiptiles ? document.querySelector('#productlist-tiptile-' + this.product.tiptiles.id) : document.querySelector('#productlist-' + this.product.id)
        var _this = this
        if (_this.isInViewport($productId)) {
          // const data = _this.product
          // const ecommercePayload = [{
          //   id: data.id,
          //   name: data.product,
          //   brand: data.artist && data.artist.name,
          //   price: data.splPrice > 0 || data.spl_price > 0 ? data.splPrice || data.spl_price : data.price,
          //   category: data.category && data.category.name,
          //   list: location.pathname,
          //   position: this.position + 1
          // }]
          // this.$store.commit('GTAG_EVENT', {eventName: 'eec.product.impression',
          //   payload: {exclusive_user: this.get_exclusive_user,
          //     ecommerce: {
          //       impressions: ecommercePayload
          //     }
          //   }}
          // )
          window.removeEventListener('scroll', this.scrollHandler)
        }
      },
      getMockUpTagPositionClass: function (mockUpTagPosition) {
        switch (mockUpTagPosition) {
          case 'BOTTOM_LEFT':
            return this.timerData && this.timerData.showCountDown ? 'mockup-tag-bottom-left-timer' : 'mockup-tag-bottom-left'
          case 'BOTTOM_RIGHT':
            return this.timerData && this.timerData.showCountDown ? 'mockup-tag-bottom-right-timer' : 'mockup-tag-bottom-right'
          case 'TOP_LEFT':
            return 'mockup-tag-top-left'
          case 'TOP_RIGHT':
            return 'mockup-tag-top-right'
          default:
            return ''
        }
      },
      isExternalLink: function (navLink) {
        return navLink && typeof navLink === 'string' && navLink.startsWith('http')
      },
      checkLabelStatus: function () {
        if (this.mockUpLabel && Object.keys(this.mockUpLabel).length) {
          const now = new Date()
          if (moment(now) >= moment(this.mockUpLabel.label_start_time) && moment(now) < moment(this.mockUpLabel.label_end_time)) {
            this.isLabelLieInTime = true
          } else {
            this.isLabelLieInTime = false
            clearInterval(this.labelTimeInterval)
          }
        }
      },
      isWishlist (item) {
        if (this.callerComp === 'Search Page' && this.callerComp !== 'PLP Page') {
          return !this.disableWishlist && item && item.prod_type !== 6 && !this.isCorporateProduct(item.artist_slug) && !item.tiptiles
        }
        return !this.disableWishlist && item && item.prodType !== 6 && !(item.artist && this.isCorporateProduct(item.artist.slug)) && !item.tiptiles && !(this.saleDet && this.saleDet.enable_daily_drop_web && this.hideWishlist)
      },
      getProductUrl
    },
    beforeDestroy () {
      if (this.product) {
        window.removeEventListener('scroll', this.scrollHandler)
      }
      if (this.labelTimeInterval) {
        clearInterval(this.labelTimeInterval)
      }
    },
    mounted () {
      setTimeout(() => {
        console.log(this.$parent.isDesktop, 'Chekcing_desktop_view')
      }, 2000)
      if (this.product) {
        window.addEventListener('scroll', this.scrollHandler, false)
      }
      this.now = this.formatTime()
      this.isPrImgMounted = true
    },
    computed: {
      ...mapGetters({bannerPlaceHolderData: 'bannerPlcaeHolderData', isExclusive: 'isExclusive', memberSavingsTxt: 'memberSavingsTxt', tatvicProductImpression: 'tatvicProductImpression', disableWishlist: 'disableWishlist', get_exclusive_user: 'get_exclusive_user', authStatus: 'authStatus', nonMemberSavingsTxt: 'nonMemberSavingsTxt', currencySymbol: 'currencySymbol', isSelectedCountryIndia: 'isSelectedCountryIndia'}),
      showExclusive: function () {
        return this.exclusivePrice && !this.isExclusive && this.exclusivePrice < this.productPrice && ((this.spprice && this.exclusivePrice < this.spprice) || !this.spprice)
      },
      currentRouteMoengage: function () {
        return getLastPage(this.$route.name)
      },
      showPriceInclusiveOnPlp () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'PLP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'SHOW_INC_OF_TEX_TEXT_PLP_WEB')
      },
      enableVincenzeSearch () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'Search Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'SHOW_VINCENZE_SEARCH')
      },
      showMemberExclusivePrice () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'PLP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'GRADIENT_MEMBER_PRICE_PLP_WEB')
      },
      isBlurProductClickable () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'PLP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'PLP_BLUR_PRODUCT_CLICKABLE_WEB')
      },
      isBlurProductClickablePdp () {
        let data = this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'PDP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'PDP_BLUR_PRODUCT_CLICKABLE_WEB')
        if (this.product.isBlurOnPlp) {
          if (data) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      },
      isTargetDateInFuture () {
        return this.product && this.product.targetDate && new Date(this.product.targetDate) > new Date()
      },
      showMrpOnPlpGlobal () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'PLP Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type === 'GLOBAL_MRP_TEXT_PLP_WEB')
      },
      isExclusiveSavingsInPercent: function () {
        const excSavingsInPercent = this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true &&
          bannerData.product_type.toLowerCase() === 'SHOW_EXC_SAVING_PERCENT_PLP'.toLowerCase())
        return excSavingsInPercent
      },
      isNonExclusiveSavingsInPercent: function () {
        const nonExcSavingsInPercent = this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find(bannerData =>
          bannerData.placeholder_for.toLowerCase() === 'PLP Screen'.toLowerCase() && bannerData.status === true &&
          bannerData.product_type.toLowerCase() === 'NO_EXC_SAVING_PERCENT_PLP_WEB'.toLowerCase())
        return nonExcSavingsInPercent
      },
      mockUpTag: function () {
        return this.plpMockUpTags && this.plpMockUpTags.find(item => item.product_slug === this.urlKey && item.is_active_plp && item.tag_name)
      },
      mockUpLabel: function () {
        return this.plpMockUpTags && this.plpMockUpTags.find(item => item.product_slug === this.urlKey && item.label && item.label.label_is_active_plp)
      },
      getProductPrice () {
        if (this.getround(this.spprice) || (this.isExclusive && this.getround(this.exclusivePrice))) {
          return this.isExclusive ? this.exclusivePrice && this.getround(this.exclusivePrice) : this.spprice && this.getround(this.spprice)
        } else if (['50000-points-offer', '25000-points-offer', '12000-points-offer'].includes(this.urlKey)) {
          return this.$parent.$parent.currencyFormate(this.getround(this.productPrice))
        } else {
          return this.productPrice && this.getround(this.productPrice)
        }
      },
      getTatvicprImpression () {
        if (this.callerComp && this.callerComp === 'Search Page') {
          return {
            item_name: this.product && this.product.product,
            item_id: this.product && (this.product.id || this.product.prod_id),
            price: this.getProductPrice,
            item_category: this.product && this.product.category && this.product.category.name || this.product.category[0] || this.productCat || this.product.category,
            item_list_name: this.$refs.filterOptions && this.$refs.filterOptions.isFilterApplied ? 'Filter Page' : (this.headingTitle ? this.headingTitle : this.callerComp || ''),  // item list name for eg, search results, category page, similar products, top selling
            index: this.position,
            image_url: String(this.baseImgPath + this.path + (this.parry && this.parry[0])),
            image_arr: String(this.baseImgPath + this.path + (this.parry && this.parry[0])) && String(this.baseImgPath + this.path + (this.parry && this.parry[0])).split('?'),
            image_name: String(this.parry && this.parry[0]),
            currency: 'INR',
            searchTerm: this.searchTerm,
            item_brand: 'The Souled Store',
            discount: this.spprice > 0 || (this.exclusivePrice > 0 && this.isExclusive) ? this.getround(this.productPrice) - this.getround(((this.isExclusive ? this.exclusivePrice : this.spprice) || 0)) : 0
          }
        }
        return {
          item_name: this.product && this.product.product,
          item_id: this.product && (this.product.id || this.product.prod_id),
          price: this.getProductPrice,
          item_category: this.product && this.product.category && this.product.category.name || this.productCat || this.product.category,
          item_list_name: this.$refs.filterOptions && this.$refs.filterOptions.isFilterApplied ? 'Filter Page' : (this.headingTitle ? this.headingTitle : this.callerComp || ''),  // item list name for eg, search results, category page, similar products, top selling
          index: this.position,
          image_url: String(this.baseImgPath + this.path + (this.parry && this.parry[0])),
          image_arr: String(this.baseImgPath + this.path + (this.parry && this.parry[0])) && String(this.baseImgPath + this.path + (this.parry && this.parry[0])).split('?'),
          image_name: String(this.parry && this.parry[0]),
          currency: 'INR',
          item_brand: 'The Souled Store',
          discount: this.spprice > 0 || (this.exclusivePrice > 0 && this.isExclusive) ? this.getround(this.productPrice) - this.getround(((this.isExclusive ? this.exclusivePrice : this.spprice) || 0)) : 0
        }
      },
      getMoengageImpressionData () {
        if (this.product) {
          return {
            item_artist: this.productCat,
            item_url: window.location.origin + '/product/' + this.urlKey + '?gte' + '=' + (this.genderType || 0),
            item_image_url: this.baseImgPath + this.path + (this.parry && this.parry[0]),
            plp_url: window.location.origin + this.$route.path
          }
        }
      },
      getBannerImpressionData () {
        if (this.product && this.product.tiptiles) {
          return {
            promotion_id: this.product.tiptiles.id || '',
            promotion_name: this.product.tiptiles.promotionName || '',
            creative_name: this.product.tiptiles.name || '',
            creative_slot: this.position,
            currency: 'INR'
          }
        }
      },
      showCarouselImagesPlpOnDesktop () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find((bannerData) =>
          bannerData.status === true && bannerData.placeholder_for === 'PLP Screen' && bannerData.product_type === 'SHOW_CAROUSEL_PLP_WEB')
      },
      showCarouselImagesPlpOnMSite () {
        return this.bannerPlaceHolderData && this.bannerPlaceHolderData.length && this.bannerPlaceHolderData.find((bannerData) =>
          bannerData.status === true && bannerData.placeholder_for === 'PLP Screen' && bannerData.product_type === 'SHOW_CAROUSEL_PLP_MOBILE_SITE')
      },
      showCarouselImages () {
        return (this.callerComp === 'PLP Page' || this.callerComp === 'Search Page') && ((this.isDesktop && this.showCarouselImagesPlpOnDesktop) || (!this.isDesktop && this.showCarouselImagesPlpOnMSite))
      }
    },
    watch: {
      mockUpLabel: function (labelObj) {
        if (labelObj && Object.keys(labelObj).length) {
          const now = new Date()
          if (now && labelObj.label_start_time && labelObj.label_end_time && moment(now) > moment(labelObj.label_start_time) && moment(now) < moment(labelObj.label_end_time)) {
            this.isLabelLieInTime = true
            this.labelTimeInterval = setInterval(() => {
              this.checkLabelStatus()
            }, 1000)
          }
        }
      }
    }
  }
</script>
<style scoped>
  .starRating {
    width: 13px;
    height: 13px;
  }
  .ratingPLP {
    column-gap: 6px;
    position: absolute;
    padding: 6px;
    bottom: 16px;
    right: 8px;
    background-color: grey;
    z-index: 1;
    font-size: 12px;
    font-weight: 700;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    border-radius: 2px;
    background-color: hsla(0,0%,100%,.8);
  }
  .offer {
    color: #58595B;
    margin-right: 5px;
  }
  .product-price {
    font-size: 14px;
    white-space: nowrap;
  }
  .ex-price {
    font-size: 14px;
    color: #3498db;
  }
  .fa-info-circle {
    margin-left: 2px;
  }
  .fa-info-circle:before {
    font-size: 12px;
  }
  .percentage-off {
    margin-left: 5px;
    font-size: 14px;
    color: #E66A51;
  }
  .member-savings {
    margin-left: unset;
  }
  .timer-container {
    bottom: 0;
  }
  .img-blur {
    opacity: 0.94;
    filter: blur(3px);
  }
  .mockup-tag {
    position: absolute;
    text-transform: uppercase;
    top: 25px;
    font-size: 10px;
    font-weight: 600;
    display: flex;
    width: 5.1rem;
    text-align: center;
  }
  .mockup-tag span {
    width: 100%;
    padding: 0px 8px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .mockup-tag-top-left {
    top: 25px;
  }
  .mockup-tag-top-right {
    top: 25px;
    right: 0;
  }
  .mockup-tag-top-right span {
    border-radius: unset;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  .mockup-tag-bottom-left {
    top: unset;
    bottom: 25px;
  }
  .mockup-tag-bottom-left-timer {
    top: unset;
    bottom: 60px;
  }
  .mockup-tag-bottom-right {
    top: unset;
    bottom: 25px;
    right: 0;
  }
  .mockup-tag-bottom-right span {
    border-radius: unset;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  .mockup-tag-bottom-right-timer {
    top: unset;
    bottom: 60px;
    right: 0;
  }
  .mockup-tag-bottom-right-timer span {
     border-radius: unset;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  .category-txt {
    max-width: 53%
  }
  .label-container {
    color: black;
    max-width: 40%
  }
  .label-container span {
    font-size: 8px;
    background-color: #f2de2b;
    padding: 1px 5px;
    border-radius: 3px;
  }
  .label-container i {
    font-size: 9px;
    color: black;
    border-width: 2px;
    border-style: solid;
    padding: 0.5px 3px;
    border-radius: 50%;
    background-color: #ffffff;
    left: -10px;
  }
  .gstInclusiveLabel {
    font-size: 14px;
    padding-left: 10px;
  }

@media screen and (max-width: 1024px) {
   .percentage-off {
    font-size: 12px;
  }
  .special-products_pricing {
    padding-left: 5px !important;
    padding-right: 0px !important;
  }
  .pdp-slider-listing .imgBlock.custom-border.listhover {
    height: 264px !important;
    width: 197px;
  }
  .pdp-slider-listing .imgBlock.custom-border.listhover img {
    height: 264px !important;
  }
  .pdp-slider-listing .productCard {
    width: 197px;
  }
}
@media only screen and (max-width: 850px) {
    .pdp-slider-listing .imgBlock.custom-border.listhover {
    height: 233px !important;
    width: 175px;
  }
  .pdp-slider-listing .imgBlock.custom-border.listhover img {
    height: 233px !important;
  }
  .pdp-slider-listing .productCard {
    width: 175px;
  }
}
@media screen and (max-width: 768px) {
  .pdp-slider-listing .imgBlock.custom-border.listhover {
    height: 196px !important;
    width: 147px;
  }
  .pdp-slider-listing .imgBlock.custom-border.listhover img {
    height: 196px !important;
  }
  .pdp-slider-listing .productCard {
    width: 147px;
  }
  .custom-full-border{
    border-radius: 5px;
  }
  .similiarProdMobile {
    width: 148px;
  }
  .custom-border{
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  .mockup-tag {
    top: 19px;
    font-size: 9px;
    width: 4.5rem;
  }
  .mockup-tag-top-left {
    top: 19px;
  }
  .mockup-tag-top-right {
    top: 19px;
    right: 0;
  }
  .mockup-tag-bottom-left {
    top: unset;
    bottom: 19px;
  }
  .mockup-tag-bottom-left-timer {
    top: unset;
    bottom: 42px;
  }

  .mockup-tag-bottom-right {
    top: unset;
    bottom: 19px;
    right: 0;
  }
  .mockup-tag-bottom-right-timer {
    top: unset;
    bottom: 42px;
    right: 0;
  }
  .mockup-tag span {
    width: 100%;
    padding: 0px 6px;
  }
  .wishlistIcon.wishlist:before{
    content: "\f08a";
    color: #000;
  }
  .wishlistIcon.wishlist {
    box-shadow: none;
    background:transparent;
  }
  .wishlistIcon {
    position: unset !important;
    background: transparent;
    box-shadow: none;
    line-height: 28px;
  }
  .wishlistAnimation {
    animation: mymove 1s;
  }
  @keyframes mymove {
    100% {transform: rotateY(360deg);}
  }
  .wishlistIcon:hover, .wishlistIcon.wishlistActive {
    background: transparent;
    box-shadow: none;
  }
}
  @media screen and (max-width: 480px) {
    .ex-price {
      font-size: 11px;
    }
    .gstInclusiveLabel {
      font-size: 12px;
      padding-left: 5px;
    }
  }
  @media screen and (max-width: 480px) {
    .fa-info-circle {
      margin-left: 0;
    }
    .percentage-off {
      font-size: 12px;
    }
    .offer {
      font-size: 12px;
    }
    .product-price {
      font-size: 12px;
    }
    .category-txt {
      max-width: 50%;
    }
    .label-container {
      max-width: 42%
    }
    .label-container i {
      font-size: 7px;
      padding: 0.8px 3px;
      left: -8px;
    }
    .label-container span {
      font-size: 6px;
      padding: 1px 3px 1px 5px;
    }
    .membership-product-price{
        font-size: 10px;
    }  
  }
  @media screen and (max-width: 360px) {
    .percentage-off {
      font-size: 11px;
    }
  }
  @media screen and (max-width: 320px) {
    .percentage-off {
      font-size: 9px;
    }
    .offer {
      font-size: 10px;
    }
    .product-price {
      font-size: 10px;
    }
    .membership-product-price{
        font-size: 10px;
    }  
  }
  @media screen and (max-width : 780px) and (min-width: 480px) {
    .membership-product-price{
      font-size: 0.8em;
    }    
  }
  .coming-soon {
    background: green;
    color: #fff;
    position: absolute;
    text-transform: uppercase;
    top: 10px;
    padding: 5px 20px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .product-image-container {
    position: relative;
    text-align: center;
  }

  .product-image {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .fade-in-out {
    animation: fadeInOut ease 3s infinite;
    -webkit-animation: fadeInOut ease 3s infinite;
    -moz-animation: fadeInOut ease 3s infinite;
    -o-animation: fadeInOut ease 3s infinite;
    -ms-animation: fadeInOut ease 3s infinite;
  }

  @keyframes fadeInOut{
    0%, 100% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }

  @-moz-keyframes fadeInOut {
    0%, 100% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }

  @-webkit-keyframes fadeInOut {
    0%, 100% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }

  @-o-keyframes fadeInOut {
    0%, 100% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }

  @-ms-keyframes fadeInOut {
    0%, 100% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }
.mrp-text {
  font-size: 16px;
  color: #888;
}
.membership-product-price{
  background: linear-gradient(to right, #F4E9FD, #D8C0E9, #D6F1FE, #F2F1FE, #D9C1EA, #F8DEF4);
  padding: 4px;
  margin-right: 4px;
  white-space: nowrap;
}
</style>
<style>
</style>



// WEBPACK FOOTER //
// imgBlock.vue?61c8d644